import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { NurseryActivityParameterService } from '../proxy/controlling/controllers/nursery-activity-parameter.service';
import { QualityControlService } from '@woodsecurity/proxy/wood-security/controllers/quality-control.service';

FieldBuilder.setNamespace('Controlling');

export const NURSERYACTIVITYQUALITYCONTROL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('nurseryActivityParameterId', 'Entity.NurseryActivityParameter', NurseryActivityParameterService)
    .required()
    .display('name') 
    .keyField('id') 
    .hideInChildForms()
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('qualityControlId', 'Entity.NurseryActivityQualityControl.QualityControl', QualityControlService)
    .required()
    .display('name') 
    .keyField('id') 
    .build(),
];

export const NURSERYACTIVITYQUALITYCONTROL_CONFIG = {
  entityName: 'NurseryActivityQualityControl',
  localizationKey: 'Controlling::Entity.NurseryActivityQualityControl',
  fields: NURSERYACTIVITYQUALITYCONTROL_FIELDS,
  permission: 'ControllingActivities.NurseryActivityQualityControls',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
